/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"
import router from '../../router'
import moment from 'moment'

export default {
   

    // JWT
    loginJWT({ commit }, payload) {

      return new Promise((resolve,reject) => {
        jwt.login(payload.userDetails.email, payload.userDetails.password)
          .then(response => {

            // If there's user data in response
            if(response.data.access_token) {
              // Navigate User to homepage

              ////router.push({ path: '/' })
              //router.push(router.currentRoute.query.to || 'home').catch((err) => {console.log(err)})

              // Set accessToken
              localStorage.setItem("accessToken", response.data.access_token)
              localStorage.setItem("refreshToken", response.data.refresh_token)

              const tokensExpiry = moment().add(response.data.expires_in,'seconds');
              localStorage.setItem("tokensExpiry", tokensExpiry);

              // Update user details
              const userDefaults = {
                uid         : 0,          // From Auth
                displayName : payload.userDetails.email, // From Auth
                about       : "",
                photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
                status      : "online",
                userRole    : "admin"
              }
              commit('UPDATE_USER_INFO', userDefaults, {root: true})

              // Set bearer token in axios
              commit("SET_BEARER", response.data.access_token)

              resolve(response)
            }else {
              reject({message: "Wrong Email or Password"})
            }

          })
          .catch(error => { reject(error) })
      })
    },
    registerUserJWT({ commit }, payload) {

      const { displayName, email, password, confirmPassword } = payload.userDetails

      return new Promise((resolve,reject) => {

        // Check confirm password
        if(password !== confirmPassword) {
          reject({message: "Password doesn't match. Please try again."})
        }

        jwt.registerUser(displayName, email, password)
          .then(response => {
            // Redirect User
            router.push(router.currentRoute.query.to || '/credentials/sigep')

            // Update data in localStorage
            localStorage.setItem("accessToken", response.data.accessToken)
            commit('UPDATE_USER_INFO', response.data.userData, {root: true})

            resolve(response)
          })
          .catch(error => { reject(error) })
      })
    },
    fetchAccessToken() {
      return new Promise((resolve) => {
        jwt.refreshToken().then(response => { resolve(response) })
      })
    }
}
